import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingOutlined, SearchOutlined, ShoppingOutlined, UserOutlined } from '@ant-design/icons';
import { Space, Spin } from 'antd';
import { findIndex } from 'lodash';
import { getCity, getDistrict, getWard, getThuongHieu, kichHoatBaoHanh, getMaDaiLyBan, getProductNameKichHoat } from '../../redux/category/action';
import { Table, DatePicker } from 'antd';
import moment from 'moment';

const KichHoat = () => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({});
  const [tableBank, setTableBank] = useState(false);
  const [thanhphoModal, setThanhphoModal] = useState(false);

  const listCity = useSelector((store) => store.categories.listCity);
  const listDistrict = useSelector((store) => store.categories.listDistrict);
  const listWard = useSelector((store) => store.categories.listWard);

  const listThuongHieu = useSelector((store) => store.categories.listThuongHieu);
  const tensanpham = useSelector((store) => store.categories.getProductNameKichHoat);
  const resultkichhoat = useSelector((store) => store.categories.getKichHoatBaoHanh);
  const resultMaDaiLyBan = useSelector((store) => store.categories.getMaDaiLyBan);
  const [tenThuongHieu, setTenThuongHieu] = useState('');
  const [serial, setSerial] = useState('');
  const [date, setDate] = useState('');

  const [city, setCity] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [district, setDistrict] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [ward, setWard] = useState(null);
  const [wardId, setWardId] = useState(null);

  const [maDailyBan, setMaDailyBan] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [muaHangSan, setMuaHangSan] = useState(false);

  const [textErrorMessage, setTextErrorMessage] = useState('');

  const [filteredCities, setFilteredCities] = useState(listCity);
  const [filterText, setFilterText] = useState('');

  const [textErrorMessageKichHoat, setTextErrorMessageKichHoat] = useState('');

  const [dateError, setDateError] = useState('');

  const [isActivating, setIsActivating] = useState(false);
  const [isSearchingProduct, setIsSearchingProduct] = useState(false);

  const [loading, setisLoading] = useState(false);

  const resultMessageRef = useRef(null);

  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  useEffect(() => {
    dispatch(getCity());
    dispatch(getThuongHieu(''));
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0); // Đưa trang lên đầu ngay lập tức
    }, 0);
  }, []);
  useEffect(() => {
    if (resultkichhoat) {
      if (!resultkichhoat.status) {
        setTextErrorMessageKichHoat(resultkichhoat.message);
      } else if (resultkichhoat.status) {
        setDisableButton(false);
        setTextErrorMessageKichHoat(resultkichhoat.message);
      }
    }
  }, [resultkichhoat, tenThuongHieu]);

  useEffect(() => {
    if (resultkichhoat?.status !== undefined && resultMessageRef.current) {
      resultMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [resultkichhoat]);

  // Mã đại lý bán tạm thời không dùng ở BE nên bỏ qua việc chặn nút submit theo trường này
  // useEffect(() => {
  //   if (muaHangSan) {
  //     setTextErrorMessage('');
  //     setDisableButton(true);
  //     return;
  //   }
  //   if (resultMaDaiLyBan.length > 0) {
  //     setTextErrorMessage('');
  //     setDisableButton(true);
  //   } else if (maDailyBan == '') {
  //     setTextErrorMessage('');
  //     setDisableButton(false);
  //   } else {
  //     setTextErrorMessage('Mã đại lý không chính xác, vui lòng kiểm tra lại hoặc liên hệ nhân viên bán hàng để đc trợ giúp.');
  //     setDisableButton(false);
  //   }
  // }, [resultMaDaiLyBan, textErrorMessage, tensanpham, muaHangSan]);

  useEffect(() => {
    if (filterText != '') {
      dispatch(getDistrict(cityId));
    }
  }, [cityId]);

  useEffect(() => {
    if (districtId != null) {
      dispatch(getWard(districtId));
    }
  }, [districtId]);

  useEffect(() => {
    findIndex(listCity, (item) => {
      if (item.ProvinceName == city) {
        setCityId(item.ProvinceID);
        setDistrict('');
      }
    });
  }, [city]);

  useEffect(() => {
    findIndex(listDistrict, (item) => {
      if (item.DistrictName == district) {
        setDistrictId(item.DistrictID);
      }
    });
  }, [district]);

  useEffect(() => {
    findIndex(listWard, (item) => {
      if (item.WardName == ward) {
        setWardId(item.DistrictID);
      }
    });
  }, [ward]);

  const onSubmit = async (data) => {
    if (!date) {
      setDateError('Vui lòng chọn ngày mua hàng');
      return;
    }
    setDateError('');

    const body = {
      Serial: serial,
      MA_KH_KICH_H0AT: maDailyBan,
      NGAY_MUA_HANG: date,
      MA_NHOM_HANG: tenThuongHieu,
      SO_DIEN_THOAI: data.SO_DIEN_THOAI,
      HO_VA_TEN: data.HO_VA_TEN,
      DIA_CHI: data.DIA_CHI,
      THANH_PHO: data.city,
      QUAN_HUYEN: data.district,
      PHUONG_XA: data.ward,
      USER_NAME: '',
    };

    setIsActivating(true);
    try {
      await dispatch(kichHoatBaoHanh(body));
    } finally {
      setIsActivating(false);
    }
  };

  const columnsBank = [
    {
      title: '',
      dataIndex: 'MA_NHOM_HANG',
      key: 'MA_NHOM_HANG',
      render: (file_path_PI, record, index) => {
        return (
          <input
            value={record.MA_NHOM_HANG}
            name="MA_NHOM_HANG"
            onClick={() => {
              setTenThuongHieu(record.MA_NHOM_HANG);
              setTableBank(false);
            }}
            style={{
              width: '100%',
              border: 'none',
              background: 'transparent',
              outline: 'none',
              cursor: 'pointer',
            }}
            readOnly
          />
        );
      },
    },
  ];

  const columnsCity = [
    {
      title: '',
      dataIndex: 'ProvinceName',
      key: 'ProvinceName',
      render: (file_path_PI, record, index) => {
        return (
          <input
            value={record.ProvinceName}
            name="ProvinceName"
            onClick={() => {
              setFilterText(record.ProvinceName);
              setCityId(record.ProvinceID);
            }}
            style={{
              width: '100%',
              border: 'none',
              background: 'transparent',
              outline: 'none',
              cursor: 'pointer',
            }}
            readOnly
          />
        );
      },
    },
  ];

  const onChange = async (event) => {
    var value = event.target.value;
    var name = event.target.name;
    if (value != null && name == 'thuonghieu') {
      await setTenThuongHieu(value);
      await dispatch(getThuongHieu(value));
    }
    if (name == 'serial') {
      setSerial(value);
    }
    if (name == 'madaily') {
      setMaDailyBan(value);
      setisLoading(true);
    }
    if (name == 'city') {
      setFilterText(value);
      filterCities(value);
    }
  };

  const onChangeDatetime = (date, dateString) => {
    setDate(dateString);
    setDateError('');
  };

  const handleChangeDistrict = (e) => {
    setDistrict(e.target.value);
  };

  const handleChangeWard = (e) => {
    setWard(e.target.value);
  };

  const onBlur = async (event) => {
    var value = event.target.value;
    var name = event.target.name;
    if (name == 'thuonghieu') {
      setTimeout(() => {
        setTableBank(false);
      }, 200);
    }
    if (name == 'madaily') {
      setisLoading(false);
      setMaDailyBan(value);
      await dispatch(getMaDaiLyBan(value));
    }

    console.log(tensanpham);
    if (name == 'city') {
      setTimeout(() => {
        setThanhphoModal(false);
      }, 200);
    }
  };

  const handleSearchProduct = async () => {
    if (!serial || !tenThuongHieu) {
      return;
    }
    setIsSearchingProduct(true);
    try {
      await dispatch(getProductNameKichHoat(serial, tenThuongHieu));
    } finally {
      setIsSearchingProduct(false);
    }
  };

  const onChangeMuaHangSan = (event) => {
    const checked = event.target.checked;
    setMuaHangSan(checked);
    if (checked) {
      setMaDailyBan('');
      setTextErrorMessage('');
    }
  };

  const filterCities = (criteria) => {
    const filtered = listCity.filter((city) => city.ProvinceName.toLowerCase().includes(criteria.toLowerCase()));
    setFilteredCities(filtered);
  };

  return (
    <div className="kich-hoat-page">
      <style>{`
                .kich-hoat-page {
                    background: linear-gradient(180deg, #f6f9fc 0%, #eef2f7 100%);
                    min-height: 100vh;
                    padding: 28px 16px 64px;
                }
                .kich-hoat-page .kh-icon-circle {
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    margin: 0 auto 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                    color: #fff;
                    background: linear-gradient(135deg, #1677ff, #4dabf7);
                    box-shadow: 0 10px 24px rgba(22, 119, 255, 0.28);
                }
                .kich-hoat-page .kh-card {
                    border: none;
                    border-radius: 18px;
                    box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
                }
                .kich-hoat-page .kh-card-header {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 20px 24px 0;
                    background: transparent;
                    border: none;
                }
                .kich-hoat-page .kh-card-header .kh-card-icon {
                    width: 36px;
                    height: 36px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #e8f2ff;
                    color: #1677ff;
                    font-size: 16px;
                }
                .kich-hoat-page .kh-card-body {
                    padding: 12px 24px 24px;
                }
                .kich-hoat-page .form-label {
                    font-weight: 600;
                    font-size: 0.86rem;
                    color: #475569;
                    letter-spacing: 0.2px;
                }
                .kich-hoat-page .form-control,
                .kich-hoat-page .form-select {
                    border-radius: 10px;
                    border-color: #dfe5ec;
                    padding: 9px 14px;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease;
                }
                .kich-hoat-page .form-control:focus,
                .kich-hoat-page .form-select:focus {
                    border-color: #4dabf7;
                    box-shadow: 0 0 0 0.2rem rgba(77, 171, 247, 0.18);
                }
                .kich-hoat-page .kh-dropdown-table {
                    border-radius: 10px;
                    overflow: hidden;
                    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
                }
                .kich-hoat-page .kh-dropdown-table .ant-table-tbody > tr:hover > td {
                    background: #eaf3ff !important;
                    cursor: pointer;
                }
                .kich-hoat-page .kh-checkbox-row {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: fit-content;
                    padding: 10px 16px;
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    cursor: pointer;
                    transition: border-color 0.15s ease, background 0.15s ease;
                }
                .kich-hoat-page .kh-checkbox-row:hover {
                    border-color: #4dabf7;
                    background: #f0f7ff;
                }
                .kich-hoat-page .kh-search-btn {
                    border-radius: 999px;
                    font-weight: 600;
                    padding: 6px 18px;
                }
                .kich-hoat-page .kh-submit-btn {
                    border: none;
                    border-radius: 999px;
                    padding: 12px 56px;
                    font-weight: 700;
                    font-size: 1.05rem;
                    background: linear-gradient(135deg, #1677ff, #4dabf7);
                    box-shadow: 0 10px 24px rgba(22, 119, 255, 0.3);
                }
                .kich-hoat-page .kh-submit-btn:disabled {
                    background: #cbd5e1;
                    box-shadow: none;
                }
            `}</style>

      <div className="container" style={{ maxWidth: 1180 }}>
        <div className="mb-5 text-center">
          <div className="kh-icon-circle">
            <ShoppingOutlined />
          </div>
          <h3 className="text-uppercase fw-bold mb-2">Kích hoạt bảo hành</h3>
          <h6 className="text-secondary fw-normal mb-0">Kích hoạt bảo hành cho sản phẩm của Giga digital bằng Serial</h6>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="card kh-card h-100">
                <div className="kh-card-header">
                  <span className="kh-card-icon">
                    <ShoppingOutlined />
                  </span>
                  <h5 className="fw-bold mb-0">Thông tin sản phẩm</h5>
                </div>
                <div className="kh-card-body">
                  <div className="mb-3">
                    <label className="form-label">
                      Số Serial <span className="require">(*)</span>
                    </label>
                    <input className="form-control" required name="serial" onChange={onChange} placeholder="Nhập số serial sản phẩm" />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Thương hiệu <span className="require">(*)</span>
                    </label>
                    <div style={{ position: 'relative' }}>
                      <input
                        onClick={() => setTableBank(!tableBank)}
                        className="form-control"
                        name="thuonghieu"
                        required
                        onBlur={onBlur}
                        value={tenThuongHieu}
                        onChange={onChange}
                        placeholder="Chọn thương hiệu"
                      />
                      {tableBank && (
                        <Table
                          columns={columnsBank}
                          dataSource={listThuongHieu}
                          pagination={false}
                          scroll={{ y: 300 }}
                          className="kh-dropdown-table"
                          style={{ position: 'absolute', top: 50, zIndex: 1, width: '100%' }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="mb-3">
                    <button
                      type="button"
                      className="btn btn-outline-primary kh-search-btn"
                      disabled={!serial || !tenThuongHieu || isSearchingProduct}
                      onClick={handleSearchProduct}
                    >
                      {isSearchingProduct ? (
                        <>
                          <Spin indicator={<LoadingOutlined spin />} size="small" className="me-2" />
                          Đang tìm kiếm...
                        </>
                      ) : (
                        <>
                          <SearchOutlined className="me-1" /> Tìm kiếm sản phẩm
                        </>
                      )}
                    </button>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Model</label>
                    <input disabled value={tensanpham?.MODEL ?? ''} className="form-control" style={{ backgroundColor: '#fff', color: '#212529' }} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Tên sản phẩm</label>
                    <textarea
                      disabled
                      value={tensanpham?.TEN_HANG ?? ''}
                      className="form-control"
                      style={{ backgroundColor: '#fff', color: '#212529' }}
                      {...register('TEN_SAN_PHAM')}
                    />
                    {tensanpham == '' && (
                      <span className="require d-block small mt-1">
                        Serial bạn nhập không tồn tại, vui lòng kiểm tra lại hoặc liên hệ hotline 1900.633.870 để được trợ giúp
                      </span>
                    )}
                  </div>

                  {/* BE hiện không dùng Mã đại lý bán, tạm thời ẩn checkbox + ô nhập này
                  <div className="mb-3">
                    <label htmlFor="muaHangSan" className="kh-checkbox-row">
                      <input
                        type="checkbox"
                        id="muaHangSan"
                        checked={muaHangSan}
                        onChange={onChangeMuaHangSan}
                        style={{ width: 18, height: 18, cursor: 'pointer' }}
                      />
                      <span className="fw-semibold text-secondary" style={{ marginBottom: 0 }}>
                        Tôi mua hàng trên sàn
                      </span>
                    </label>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Mã đại lý bán {!muaHangSan && <span className="require">(*)</span>}</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        className="form-control"
                        name="madaily"
                        disabled={muaHangSan}
                        style={{ border: `1px solid ${!disableButton && textErrorMessage === '' ? '#dee2e6' : disableButton ? 'green' : 'red'}` }}
                        value={maDailyBan}
                        onChange={onChange}
                        onBlur={onBlur}
                        placeholder="KHGD......"
                      />
                      <div style={{ position: 'absolute', top: 5, right: 10, display: loading ? '' : 'none' }}>
                        {' '}
                        <Space>
                          {' '}
                          <Spin indicator={<LoadingOutlined spin />} size="small" />{' '}
                        </Space>{' '}
                      </div>
                    </div>
                    <span className="require d-block small mt-1">{textErrorMessage} </span>
                  </div>
                  */}

                  <div className="mb-1">
                    <label className="form-label">
                      Ngày mua <span className="require">(*)</span>
                    </label>
                    <DatePicker
                      style={{ width: '100%', borderColor: dateError ? '#dc3545' : undefined }}
                      onChange={onChangeDatetime}
                      format={'DD/MM/YYYY'}
                      disabledDate={disabledDate}
                    />
                    {dateError && <p className="text-danger mb-0 mt-1">{dateError}</p>}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="card kh-card h-100">
                <div className="kh-card-header">
                  <span className="kh-card-icon">
                    <UserOutlined />
                  </span>
                  <h5 className="fw-bold mb-0">Thông tin khách hàng</h5>
                </div>
                <div className="kh-card-body">
                  <div className="mb-3">
                    <label className="form-label">
                      Họ tên <span className="require">(*)</span>
                    </label>
                    <input className="form-control" {...register('HO_VA_TEN', { required: 'Không được để trống' })} placeholder="Nhập họ và tên" />
                    {errors.HO_VA_TEN && <p className="text-danger">{errors.HO_VA_TEN.message}</p>}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Số điện thoại <span className="require">(*)</span>
                    </label>
                    <input
                      className="form-control"
                      {...register('SO_DIEN_THOAI', { required: 'Không được để trống' })}
                      placeholder="Nhập số điện thoại"
                    />
                    {errors.SO_DIEN_THOAI && <p className="text-danger">{errors.SO_DIEN_THOAI.message}</p>}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Tỉnh / Thành phố</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        onClick={() => setThanhphoModal(!thanhphoModal)}
                        type="text"
                        className="form-control"
                        name="city"
                        placeholder="Nhập để lọc tỉnh/thành phố"
                        value={filterText}
                        onBlur={onBlur}
                        onChange={onChange}
                      />
                      {thanhphoModal && (
                        <Table
                          columns={columnsCity}
                          dataSource={filteredCities.length == 0 ? listCity : filteredCities}
                          pagination={false}
                          scroll={{ y: 300 }}
                          className="kh-dropdown-table"
                          style={{ position: 'absolute', top: 50, zIndex: 1, width: '100%' }}
                        />
                      )}

                      {errors.city && <p className="text-danger">{errors.city.message}</p>}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Quận / Huyện</label>
                    <select className="form-select" {...register('district')} value={district} onChange={(e) => handleChangeDistrict(e)}>
                      <option value={''} selected disabled>
                        Quận/Huyện
                      </option>
                      {listDistrict &&
                        listDistrict.map((item, index) => (
                          <option key={index} value={item.DistrictName}>
                            {item.DistrictName}
                          </option>
                        ))}
                    </select>
                    {errors.district && <p className="text-danger">{errors.district.message}</p>}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Phường / Xã</label>
                    <select className="form-select" {...register('ward')} value={ward} onChange={(e) => handleChangeWard(e)}>
                      <option value={''} selected disabled>
                        Phường/Xã
                      </option>
                      {listWard &&
                        listWard.map((item, index) => (
                          <option key={index} value={item.WardName}>
                            {item.WardName}
                          </option>
                        ))}
                    </select>
                    {errors.ward && <p className="text-danger">{errors.ward.message}</p>}
                  </div>

                  <div className="mb-1">
                    <label className="form-label">Địa chỉ</label>
                    <textarea className="form-control" rows={2} {...register('DIA_CHI')} placeholder="Nhập địa chỉ" />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 mt-4 text-center">
              <button disabled={!disableButton || isActivating} className="btn btn-primary kh-submit-btn">
                {isActivating ? (
                  <>
                    <Spin indicator={<LoadingOutlined spin style={{ color: '#fff' }} />} size="small" className="me-2" />
                    Đang kích hoạt...
                  </>
                ) : (
                  'Kích hoạt bảo hành'
                )}
              </button>
            </div>

            <div className="col-12" ref={resultMessageRef}>
              <div className="container-fluid text-center">
                {resultkichhoat?.status === undefined ? (
                  <> </>
                ) : !resultkichhoat?.status ? (
                  <div className="new-message-box">
                    <div className="new-message-box-danger">
                      <div className="info-tab tip-icon-danger" title="error">
                        <i />
                      </div>
                      <div className="tip-box-danger">
                        <p>
                          {textErrorMessageKichHoat.split('\n').map((line, index) => (
                            <span key={index}>
                              {line}
                              <br />
                            </span>
                          ))}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="new-message-box">
                    <div className="new-message-box-success">
                      <div className="info-tab tip-icon-success" title="success">
                        <i />
                      </div>
                      <div className="tip-box-success">
                        <p>
                          Kích hoạt thành công, Quý khách vui lòng tra cứu thời hạn bảo hành <a href="/thoi-han-bao-hanh"> tại đây. </a> Cảm ơn quý
                          khách đã ủng hộ Giga.vn!
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default KichHoat;
